
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  var parcelRequire = $parcel$global["parcelRequirea579"];
var parcelRegister = parcelRequire.register;
parcelRegister("1PbgQ", function(module, exports) {

$parcel$export(module.exports, "init", function () { return $15434c000887263a$export$2cd8252107eb640b; });

var $jG4hL = parcelRequire("jG4hL");
const $15434c000887263a$export$2cd8252107eb640b = ()=>{
    let attempts = 0;
    const $body = (0, (/*@__PURE__*/$parcel$interopDefault($jG4hL)))("body");
    const $header = (0, (/*@__PURE__*/$parcel$interopDefault($jG4hL)))("header");
    const $bottomNav = $header.find(".header__bottom-nav");
    const $navBtn = $bottomNav.find(".toggle-btn");
    const $mainNav = $bottomNav.find(".main-nav");
    const hideMobileBottomNav = ()=>{
        $navBtn.removeClass("active").attr("aria-expanded", "false");
        $bottomNav.removeClass("open");
        $mainNav.slideUp(400, function() {
            $mainNav.removeClass("show").removeAttr("style");
        });
    };
    const clickOutNavMain = (e)=>{
        if ((0, (/*@__PURE__*/$parcel$interopDefault($jG4hL)))(e.target).closest($header).length) return;
        hideMobileBottomNav();
        $body.off("click", clickOutNavMain);
    };
    const setMaxHeight = ()=>{
        if (window.innerWidth <= 991) {
            let maxHeight = window.innerHeight;
            maxHeight = maxHeight - $header.outerHeight();
            maxHeight = maxHeight - $navBtn.outerHeight();
            $mainNav.css("max-height", maxHeight);
        } else $mainNav.removeAttr("style");
    };
    const whenComplete = ()=>{
        if (++attempts > 30) return;
        if (document.readyState === "complete") {
            setMaxHeight();
            $navBtn.on("click", function() {
                if (this.getAttribute("aria-expanded") === "false") {
                    (0, (/*@__PURE__*/$parcel$interopDefault($jG4hL)))(this).addClass("active").attr("aria-expanded", "true");
                    $mainNav.addClass("show").slideDown(400);
                    $bottomNav.addClass("open");
                    $body.on("click", clickOutNavMain);
                } else {
                    hideMobileBottomNav();
                    $body.off("click", clickOutNavMain);
                }
            });
            (0, (/*@__PURE__*/$parcel$interopDefault($jG4hL)))(window).on("resize", setMaxHeight);
        } else setTimeout(()=>whenComplete(), 400);
    };
    whenComplete();
};

});


//# sourceMappingURL=headerBottomNav.module.bed71927.js.map
